<script lang="ts">
    import PageBuilder from '$lib/components/PageBuilder/PageBuilder.svelte';
    import PageSEO from '$lib/components/PageSEO/PageSEO.svelte';
    import InternalError from '$src/lib/layouts/errors/InternalError.svelte';
    import NotFound from '$src/lib/layouts/errors/NotFound.svelte';
    import type { TMarket } from '$src/lib/services/market/types';
    import type { TPageLoadResult } from '$src/lib/services/page/load.factory.server';
    import PageProperties from './PageProperties.svelte';
    import { page as pageState } from '$app/state';
    export let page: TPageLoadResult['pageData'];
    export let debug = false;
    const market = pageState.data.market as TMarket;
</script>

<svelte:head>
    {#await page then { seo: { meta, markets } }}
        <PageSEO {meta} {markets} />
    {/await}
</svelte:head>

<div>
    {#await page then { blockData, cssReferences, scriptReferences, pageProperties }}
        <PageProperties {pageProperties} />
        <PageBuilder {blockData} {cssReferences} {scriptReferences} {debug} />
    {:catch error}
        {#if error.status == 404}
            <NotFound {market} />
        {:else}
            <InternalError />
        {/if}
        <div class="hidden" data-error-id={error.errorId}>{error.errorId}</div>
    {/await}
</div>
